<template>
  <div class="layout-wrapper layout-1">
    <div class="layout-inner">
      <app-layout-navbar />

      <div class="layout-container">
        <app-layout-sidenav />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <h4 class="font-weight-bold" v-if="$route.meta.breadcrumbs">
              <span v-for="(b, index) in $route.meta.breadcrumbs" :key="index">
                <span v-if="b != $route.meta.breadcrumbs[$route.meta.breadcrumbs.length - 1]" class="text-muted font-weight-light">{{b.text}} / </span>
                <span v-else>{{b.text}} </span>
              </span>
            </h4>
            <h4 class="font-weight-bold" v-else>
              <span>{{$route.meta.title}} </span>
            </h4>

            <router-view />
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
  import LayoutNavbar from './LayoutNavbar'
  import LayoutSidenav from './LayoutSidenav'
  import LayoutFooter from './LayoutFooter'
  import { authComputed } from '../store/helpers.js'

  export default {
    name: 'app-layout-1',
    components: {
      'app-layout-navbar': LayoutNavbar,
      'app-layout-sidenav': LayoutSidenav,
      'app-layout-footer': LayoutFooter
    },
    mounted() {
      this.layoutHelpers.init()
      this.layoutHelpers.update()
      this.layoutHelpers.setAutoUpdate(true)
    },
    beforeDestroy() {
      this.layoutHelpers.destroy()
    },
    methods: {
      closeSidenav() {
        this.layoutHelpers.setCollapsed(true)
      }
    },
    computed: {
      ...authComputed
    }

  }
</script>
